export default {
  active: (state) => state.endDate !== null,
};
